import { render, staticRenderFns } from "./TerminalSalesReport.vue?vue&type=template&id=72bc81d8&"
import script from "./TerminalSalesReport.vue?vue&type=script&lang=js&"
export * from "./TerminalSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports